'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
var Modal = require('../Modal/Modal.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-headline-info',
    cnLarge = "".concat(CLASSNAME, "--lg"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnIconInfo = "".concat(CLASSNAME, "__icon-info");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function HeadlineInfo(_ref) {
  var children = _ref.children,
      level = _ref.level,
      iconId = _ref.iconId,
      large = _ref.large,
      className = _ref.className,
      info = _ref.info;
  var classes = classNames(CLASSNAME, className, "".concat(CLASSNAME, "--").concat(level), _rollupPluginBabelHelpers.defineProperty({}, cnLarge, !level || large));

  var _useState = React.useState(false),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      showInfo = _useState2[0],
      setShowInfo = _useState2[1];

  var MyH = "h".concat(level === 0 ? 1 : level);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MyH, {
    className: classes
  }, iconId && /*#__PURE__*/React__default.createElement(Icon, {
    className: cnIcon,
    id: iconId,
    size: level === 0 ? 'xl' : large ? 'lg' : 'md'
  }), /*#__PURE__*/React__default.createElement("span", null, children), info && /*#__PURE__*/React__default.createElement("div", {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setShowInfo(true);
    },
    className: cnIconInfo
  }, /*#__PURE__*/React__default.createElement(Icon, {
    id: "questionmark-alt",
    size: "xxs"
  }))), info && /*#__PURE__*/React__default.createElement(Modal, {
    onClose: function onClose() {
      return setShowInfo(false);
    },
    title: info.title,
    image: info.image,
    open: showInfo,
    showCloseButton: true
  }, /*#__PURE__*/React__default.createElement(RichText, {
    content: info.content
  })));
}
HeadlineInfo.propTypes = {
  /** Child nodes */
  children: PropTypes.node.isRequired,

  /** Additional class name */
  className: PropTypes.string,

  /** Id of icon to the left */
  iconId: PropTypes.string,

  /** Content of info modal */
  info: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string,
    content: PropTypes.string
  }),

  /** True for large styling */
  large: PropTypes.bool,

  /** Level of headline e.g. 1 for h1 */
  level: PropTypes.number
};
HeadlineInfo.defaultProps = {
  level: 1
};

module.exports = HeadlineInfo;
